import { useSnapshot } from 'valtio'
import uiState from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useEffect, useRef, useState } from 'react'
import { windowSizeState } from '../utils/windowSize'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
const Homepage = ({ event }) => {
  const { visible, data } = useSnapshot(uiState[event])
  const [isStartHover, setIsStartHover] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [canClick, setCanClick] = useState(false)

  const goVr = () => {
    let currentUrl = window.location.href
    var newUrl = currentUrl.replace('/start/start.html', '/vr/v0.html')
    window.location.href = newUrl
  }

  const goInfo = () => {
    if (canClick) {
      setShowInfo(true)
    }
  }

  const shineVariants = {
    show: {
      opacity: [0.2, 0.4, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: 'linear',
        delay: 5.1
      },
      willChange: 'transform',
      layout: 'position'
    },
    hide: {
      opacity: [0]
    }
  }

  return (
    <>
      <div className='fixed top-0 left-0 '>
        <img
          src='../startImages/bg1.png'
          alt='第一張背景'
          className='absolute top-0 left-0 w-full h-[170vh] object-cover'
        />
      </div>
      <AnimatePresence>
        {visible && (
          <motion.div
            className=' absolute top-0 left-0 screen-setting overflow-hidden '
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.div
              className='screen-setting relative '
              animate={{ y: showInfo ? '-100%' : 0 }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              <img
                src='../startImages/bg1.png'
                alt='第一張背景'
                className='absolute top-0 left-0 w-full h-[170vh] object-cover'
              />

              <img
                src='../startImages/crack.png'
                alt='紋路'
                className='absolute top-0 left-0 w-full h-full object-cover z-20'
              />
              <div className=' absolute top-[43%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40%] z-30 portraitPad:w-[65%] portraitBigPh:w-[80%] landscapePhone:w-[30%]'>
                <motion.img
                  src='../startImages/earth.png'
                  alt='地球'
                  className='w-full object-contain'
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 1.5, delay: 1.3 }}
                />
                <div className=' absolute bottom-0 right-0 w-[30%] -translate-x-[60%] -translate-y-[80%] overflow-hidden'>
                  <motion.img
                    src='../startImages/hand_right.png'
                    alt='右邊的手'
                    className=' w-full object-contain'
                    initial={{ x: '100%', opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1.3, delay: 2.5 }}
                  />
                </div>

                <div className=' absolute top-0 left-0 w-[32%] translate-x-[60%] translate-y-[75%] overflow-hidden'>
                  <motion.img
                    src='../startImages/hand_left.png'
                    alt='左邊的手'
                    className=' w-full object-contain'
                    initial={{ x: '-100%', opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1.3, delay: 2.6 }}
                  />
                </div>
                <div className=' absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  flex flex-col h-[70%] items-center  '>
                  <div className='h-[55%] w-auto  translate-y-[27%] overflow-hidden '>
                    <motion.img
                      src='../startImages/title.png'
                      alt='津甘馧'
                      className='h-[78%] w-full object-contain '
                      initial={{ y: '150%', opacity: 0 }}
                      animate={{ y: 0, opacity: 1 }}
                      transition={{ duration: 1.5, delay: 4.6 }}
                    />
                  </div>

                  <motion.div
                    className='w-[55%] relative flex justify-center  '
                    initial={{ opacity: 0, y: '-8%' }}
                    animate={{ opacity: 1, y: '-8%' }}
                    transition={{ duration: 1.3, delay: 3.6 }}
                  >
                    <img
                      src='../startImages/shadow.png'
                      alt='光與文字'
                      className=' w-full'
                    />
                    <div
                      className={`absolute bottom-[17%]  ${
                        canClick && 'cursor-pointer'
                      }`}
                      onClick={goInfo}
                    >
                      <img
                        src='../startImages/cup.png'
                        alt='杯子'
                        className={`w-full  object-contain ${
                          canClick && !isMobile && 'hover:scale-[1.05]'
                        }`}
                      />
                      <motion.img
                        src='../startImages/shine.png'
                        alt='光芒'
                        className='w-full object-contain absolute left-0 top-0 -translate-y-[100%]'
                        variants={shineVariants}
                        initial='hide'
                        animate='show'
                      />
                    </div>
                  </motion.div>
                </div>
                <motion.img
                  src='../startImages/word.png'
                  alt='用真誠感恩之心，重新連結後疫情時代的我們。'
                  className=' absolute left-1/2 -translate-x-1/2 bottom-0 translate-y-[100%] w-[85%] object-contain'
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1.5, delay: 5.6 }}
                  onAnimationComplete={() => {
                    setCanClick(true)
                  }}
                />
              </div>
            </motion.div>
            <motion.div
              className='screen-setting relative '
              animate={{ y: showInfo ? '-100%' : 0 }}
              transition={{ duration: 1, ease: 'linear' }}
            >
              <motion.img
                src='../startImages/logo.png'
                alt='左下單位'
                className=' absolute left-[3%] bottom-[3%] w-[28%] object-contain landscapePad:w-[34%] portraitPad:w-[50%] portraitBigPh:w-[70%] z-20'
                initial={{ opacity: 0 }}
                animate={{ opacity: showInfo ? 1 : 0 }}
                transition={{ duration: 0.8, delay: 2.8 }}
              />

              <img
                src='../startImages/crack.png'
                alt='紋路'
                className='absolute top-0 left-0 w-full h-full object-cover z-20'
              />
              <img
                src='../startImages/bg2.png'
                alt='第二張背景'
                className='absolute bottom-0 left-0 w-full h-full '
              />
              <motion.div
                className=' absolute top-[55%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50%] h-[69%] z-30  flex flex-col items-center landscapePad:w-[65%] portraitPad:w-[75%] portraitBigPh:w-[85%] portraitBigPh:h-[68%] portraitBigPh:top-[53%] landscapePhone:w-[85%] landscapePhone:h-[78%]'
                initial={{ opacity: 0 }}
                animate={{ opacity: showInfo ? 1 : 0 }}
                transition={{ duration: 0.8, delay: 2 }}
              >
                <div className='  text-center text-title-100 NotoSansM'>
                  <div className='text-[20px] portraitBigPh:text-[17px] landscapePhone:text-[17px]'>
                    {data.zh.title}
                  </div>
                  <div
                    className={`text-[17px] mt-3 portraitBigPh:text-[14px] whitespace-pre-wrap landscapePhone:text-[13px] `}
                  >
                    {data.en.title}
                  </div>
                </div>
                <img
                  src='../startImages/line.png'
                  alt='中間的線'
                  className='w-full my-[30px]'
                />

                <div className='w-full NotoSansR  h-full text-content-100 overflow-y-scroll'>
                  <ReactMarkdown
                    className='text-[16px]   text-justify portraitBigPh:text-[15px] '
                    children={data.zh.content}
                    rehypePlugins={[rehypeRaw]}
                  />
                  <ReactMarkdown
                    className='text-[16px]   portraitBigPh:text-[14px] mt-[24px] tracking-[1.5px] text-justify portraitPad:text-left '
                    children={data.en.content}
                    rehypePlugins={[rehypeRaw]}
                  />
                </div>

                <motion.img
                  initial={{ opacity: 0 }}
                  animate={{ opacity: showInfo ? 1 : 0 }}
                  transition={{ duration: 0.8, delay: 2.8 }}
                  src={
                    !isMobile && isStartHover
                      ? '../startImages/start_hover.png'
                      : '../startImages/start.png'
                  }
                  alt='前往參觀'
                  className='w-[220px] mt-[55px] portraitPad:mt-[30px]  cursor-pointer landscapePad:w-[180px] portraitPad:w-[180px] portraitBigPh:w-[150px] landscapePhone:w-[150px]'
                  onMouseEnter={() => {
                    setIsStartHover(true)
                  }}
                  onMouseLeave={() => {
                    setIsStartHover(false)
                  }}
                  onClick={goVr}
                />
              </motion.div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Homepage
